import React, { useEffect, useState } from "react";
import Layout from "../Layout/Content";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import axios from "axios";
import { ethers } from "ethers";
import Loading from "../LoaderPageSection/Loading";
import { stake6, stake6ABI } from "../Abi/Content";
import { switchNetwork } from "../../../utils/switchNetwork";
import "./styles.css";

const Content = () => {
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [refferalAddress, setRefferalAddress] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const start_and_end = (address) => {
    if (address !== undefined) {
      return (
        address.substr(0, 18) +
        "...." +
        address.substr(address.length - 18, address.length)
      );
    }
    return address;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (userAddress.toLowerCase() === refferalAddress.toLowerCase()) {
      toast.error("Connected wallet is same as your wallet address, Please change the referrer");
      return;
    }
    if (!window.ethereum) {
      toast.error("Ethereum wallet not detected. Please install MetaMask.");
      return;
    }
    if (!ethers.utils.isAddress(refferalAddress)) {
      toast.error("Invalid referral address, please reconnect your wallet and try again.");
      return;
    }
    setLoading(true);
    try {
      await switchNetwork('bsc');
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(stake6, stake6ABI, signer);
      let isRegisteredOnChain = false;
      try {
        const trx = await contract.registerReferral(refferalAddress.toLowerCase());
        const rcpt = await trx.wait();
        if (rcpt?.status === 1) {
          isRegisteredOnChain = true;
        } else {
          throw new Error("Blockchain transaction failed to confirm.");
        }
      } catch (contractError) {
        const errorMsg = contractError?.reason || contractError?.message || "";
        if (errorMsg.includes("Already registered")) {
          console.log("User already registered on-chain, proceeding to database registration check.");
          isRegisteredOnChain = true;
        } else if (errorMsg.includes("contract not allowed")) {
          toast.error("Registration failed because delegated wallet addresses (EIP-7702) are not supported due to platform security and compatibility requirements. Please register using a another wallet address.");
          setLoading(false);
          return;
        } else {
          throw contractError;
        }
      }

      if (isRegisteredOnChain) {
        const resp = await axios.post(`/api/user/userRegisteration`, {
          accountAddress: userAddress.toLowerCase(),
          sponserAddress: refferalAddress.toLowerCase(),
        });
        if (resp?.status === 200 && resp?.data?.status === true) {
          toast.success(resp?.data?.message || "Registered successfully!", {
            position: "top-right",
          });
          setAuth({
            ...auth,
            user: null,
          });
          localStorage.removeItem("auth");
          toast.success("User Registered Successfully! Please Connect Wallet to Login");
          navigate("/");
        } else {
          toast.error(resp?.data?.message || "Registration succeeded on-chain but failed in database.", {
            position: "top-right",
          });
        }
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const errMsg = error.response.data?.message || "Something went wrong with the database request.";
        if (status === 400) {
          setAuth({
            ...auth,
            user: null,
          });
          localStorage.removeItem("auth");
          navigate("/");
        }
        toast.error(errMsg);
      } else {
        console.error("Blockchain/Wallet Error in Register:", error);
        if (error.code === 4001) {
          toast.error("Transaction was rejected in your wallet.");
        } else {
          toast.error(error.reason || error.message || "Failed to register on blockchain.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    const defaultRefferalAddress = "0x31c2c66f56939c94d4bc743363ef4b171f1c17df";
    const rawReferral = auth?.user?.referralAddress;
    let cleanReferral = defaultRefferalAddress;
    if (rawReferral && rawReferral.trim() !== "") {
      const baseAddress = rawReferral.split("&")[0].split("?")[0].trim();
      if (ethers.utils.isAddress(baseAddress)) {
        cleanReferral = baseAddress;
      }
    }

    if (auth?.user?.address !== "") {
      setUserAddress(auth?.user?.address);
      setRefferalAddress(cleanReferral);
    }
  }, [auth]);

  return (
    <Layout title={"Register"}>
      <div className="register-page">
        {loading && <Loading loading={loading} />}
        <div className="register-card">
          <div className="register-card-header">
            <h2>Create Account</h2>
            <button
              className="register-close-btn"
              onClick={() => navigate("/")}
              type="button"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <form onSubmit={handleRegister}>
            <div className="register-field">
              <label className="register-label">Connected Wallet</label>
              <input
                type="text"
                className="register-input"
                value={start_and_end(userAddress)}
                disabled
              />
            </div>

            <div className="register-field">
              <label className="register-label">Referral Wallet</label>
              <input
                type="text"
                className="register-input"
                value={start_and_end(refferalAddress)}
                disabled
              />
              {refferalAddress ===
                "0x31c2c66f56939c94d4bc743363ef4b171f1c17df" && (
                  <span className="register-default-ref">
                    As your account is not referred by any user, you will
                    be registered with the default referral address.
                  </span>
                )}
            </div>

            <button type="submit" className="register-submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Content;
